import { TenantSettingModel } from '@app/shared/models/tenant-setting.model';
import { createAction, props } from '@ngrx/store';

export const tenantSettingChanged = createAction('[TenantSetting] change', props<TenantSettingModel>());
export const tenantSettingError = createAction('[TenantSetting] error');
